import Vue from 'vue';
import gridProps from '@/gridProps';
import { getPinnedRowData } from '@/helpers/renderHelpers';

import {
  formatNumber,
  alignForNumber,
  getNodeChildDetails,
  addGroupingInResponseData,
  LinkCellRenderer,
  autoResize
} from '@/helpers/renderHelpers';

import { addColIdToColumns, handlerResponse } from '@/helpers/commonHelpers';

export default {
  namespaced: true,
  state: {
    reports: [],
    money_flow: ['incoming', 'outgoing'],
    payments: [],
    columns: [],
    paymentsCount: null,
    totalData: [],
    gridOptions: {
      rowSelection: 'multiple',
      getNodeChildDetails: getNodeChildDetails,
      components: {
        'BuyerLink': LinkCellRenderer('buyer', '/partners/'),
        'PayerLink': LinkCellRenderer('payer', '/partners/'),
        'RecipientLink': LinkCellRenderer('recipient', '/partners/'),
        'documentNumberLink': LinkCellRenderer('invoice', '/sale/invoices/edit/', true, {
          prop: 'id',
          url: '/payments/',
          otherAppFlag: false,
          isLink: true
        }),
      },
      defaultColDef: {
        sortable: true,
        filter: true,
        resizable: true,
        valueFormatter(params) {
          return formatNumber(params.value);
        },
        cellStyle({value, colDef, data}) {
          const alignNumber = alignForNumber(value);
          if (colDef.field === 'lc_cost' && data.not_distributed_lc) {
            return {
              ...alignNumber,
              color: 'red'
            }
          }
          return alignNumber;
        }
      },
      onRowDataChanged() {
        if (this.rowData && this.rowData.length) {
          autoResize(this);
        }
      }
    },
    gridName: ''
  },
  getters: {
    payments(state) {
      return state.payments;
    },
    columns(state) {
      return state.columns;
    },
    gridOptions(state) {
      return {...state.gridOptions, ...gridProps};
    },
    paymentsCount(state) {
      return state.paymentsCount
    }
  },
  mutations: {
    setData(state, data) {
      state.payments = addGroupingInResponseData(data.data.results);
      state.columns = addColIdToColumns(data.used_columns);
      state.paymentsCount = data.data.count;
      state.gridName = data.grid_name;
      state.totalData = getPinnedRowData(data.total);
    },
    setReports(state, data) {
      state.reports = data;
    },
    setTotalData(state, data) {
      state.totalData = getPinnedRowData(data.total);
    }
  },
  actions: {
    async updateTotalPayments(store, payload) {
      try {
        const response = await Vue.http.get('partner/search_for_payments/', {params: payload});
        const data = await handlerResponse(response);
        store.commit('setTotalData', data);
      } catch (e) {
        console.log(e);
        throw Error(e);
      }
    },
    async loadPayments(store, payload) {
      try {
        const response = await Vue.http.get('partner/search_for_payments/', {params: payload});
        const data = await handlerResponse(response);
        store.commit('setData', data);
      } catch (e) {
        console.log(e);
        throw Error(e);
      }
    },
    loadPaymentsReports(store, payload) {
      Vue.http.get('partner/payments/reports/', {params: payload})
        .then(handlerResponse)
        .then(data => {
          store.commit('setReports', data);
        });
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/accounts/payments/payments.js